export default {
    topics: [
        {
            title: ' sqlExec ',
            href: 'f-sqlExec.html',
            attributes: { 'data-id': 'f-sqlExec' },
            menu: { hasChildren: false },
            tocID: 'f-sqlExec-d66e4299',
            topics: [],
        },
        {
            title: ' sqlExecOnDataSource ',
            href: 'f-sqlExecOnDataSource.html',
            attributes: { 'data-id': 'f-sqlExecOnDataSource' },
            menu: { hasChildren: false },
            tocID: 'f-sqlExecOnDataSource-d66e4307',
            topics: [],
        },
        {
            title: ' sqlGetString ',
            href: 'f-sqlGetString.html',
            attributes: { 'data-id': 'f-sqlGetString' },
            menu: { hasChildren: false },
            tocID: 'f-sqlGetString-d66e4315',
            topics: [],
        },
        {
            title: ' sqlGetStringOnDataSource ',
            href: 'f-sqlGetStringOnDataSource.html',
            attributes: { 'data-id': 'f-sqlGetStringOnDataSource' },
            menu: { hasChildren: false },
            tocID: 'f-sqlGetStringOnDataSource-d66e4323',
            topics: [],
        },
        {
            title: ' sqlGetMemo ',
            href: 'f-sqlGetMemo.html',
            attributes: { 'data-id': 'f-sqlGetMemo' },
            menu: { hasChildren: false },
            tocID: 'f-sqlGetMemo-d66e4331',
            topics: [],
        },
        {
            title: ' sqlGetMemoOnDataSource ',
            href: 'f-sqlGetMemoOnDataSource.html',
            attributes: { 'data-id': 'f-sqlGetMemoOnDataSource' },
            menu: { hasChildren: false },
            tocID: 'f-sqlGetMemoOnDataSource-d66e4339',
            topics: [],
        },
        {
            title: ' sqlGetInt ',
            href: 'f-sqlGetInt.html',
            attributes: { 'data-id': 'f-sqlGetInt' },
            menu: { hasChildren: false },
            tocID: 'f-sqlGetInt-d66e4347',
            topics: [],
        },
        {
            title: ' sqlGetIntOnDataSource ',
            href: 'f-sqlGetIntOnDataSource.html',
            attributes: { 'data-id': 'f-sqlGetIntOnDataSource' },
            menu: { hasChildren: false },
            tocID: 'f-sqlGetIntOnDataSource-d66e4355',
            topics: [],
        },
        {
            title: ' sqlGetDate ',
            href: 'f-sqlGetDate.html',
            attributes: { 'data-id': 'f-sqlGetDate' },
            menu: { hasChildren: false },
            tocID: 'f-sqlGetDate-d66e4363',
            topics: [],
        },
        {
            title: ' sqlGetDateOnDataSource ',
            href: 'f-sqlGetDateOnDataSource.html',
            attributes: { 'data-id': 'f-sqlGetDateOnDataSource' },
            menu: { hasChildren: false },
            tocID: 'f-sqlGetDateOnDataSource-d66e4371',
            topics: [],
        },
        {
            title: ' sqlGetDouble ',
            href: 'f-sqlGetDouble.html',
            attributes: { 'data-id': 'f-sqlGetDouble' },
            menu: { hasChildren: false },
            tocID: 'f-sqlGetDouble-d66e4379',
            topics: [],
        },
        {
            title: ' sqlGetDoubleOnDataSource ',
            href: 'f-sqlGetDoubleOnDataSource.html',
            attributes: { 'data-id': 'f-sqlGetDoubleOnDataSource' },
            menu: { hasChildren: false },
            tocID: 'f-sqlGetDoubleOnDataSource-d66e4388',
            topics: [],
        },
        {
            title: ' getCurrentDate ',
            href: 'f-getCurrentDate.html',
            attributes: { 'data-id': 'f-getCurrentDate' },
            menu: { hasChildren: false },
            tocID: 'f-getCurrentDate-d66e4396',
            topics: [],
        },
        {
            title: ' sqlSelect ',
            href: 'f-sqlSelect.html',
            attributes: { 'data-id': 'f-sqlSelect' },
            menu: { hasChildren: false },
            tocID: 'f-sqlSelect-d66e4404',
            topics: [],
        },
        {
            title: ' getOption ',
            href: 'f-getOption.html',
            attributes: { 'data-id': 'f-getOption' },
            menu: { hasChildren: false },
            tocID: 'f-getOption-d66e4412',
            topics: [],
        },
        {
            title: ' setOption ',
            href: 'f-setOption.html',
            attributes: { 'data-id': 'f-setOption' },
            menu: { hasChildren: false },
            tocID: 'f-setOption-d66e4420',
            topics: [],
        },
    ],
};

